import { Sparkles } from "lucide-react";
import { proxyImg } from "@/utils/imageProxy";

const BRAND_LOGO = proxyImg("https://customer-assets.emergentagent.com/job_cake-design-studio-5/artifacts/5xphm2ah_Sugar%20Bouquet%20Logo.png", 96, 80);

export default function WelcomeHeader() {
  return (
    <div className="text-center pt-8 pb-4 animate-fade-in-up" data-testid="welcome-header">
      {/* Logo */}
      <div className="mx-auto mb-6 relative">
        <div className="w-24 h-24 mx-auto rounded-full overflow-hidden border-2 border-gray-100 shadow-sm bg-white flex items-center justify-center p-1">
          <img
            src={BRAND_LOGO}
            alt="Sugar Bouquet India"
            className="w-full h-full object-contain"
            data-testid="brand-logo"
          />
        </div>
        <div className="absolute -bottom-1 left-1/2 -translate-x-1/2 bg-black text-white text-[10px] font-semibold px-2 py-0.5 rounded-full flex items-center gap-1">
          <Sparkles className="w-3 h-3" />
          AI
        </div>
      </div>

      {/* Title */}
      <h1
        className="font-display text-4xl sm:text-5xl tracking-tight text-gray-900 mb-3"
        data-testid="brand-title"
      >
        Sugar Bouquet AI Assistant
      </h1>

      {/* Subtitle */}
      <p className="text-gray-500 text-base max-w-md mx-auto leading-relaxed" data-testid="brand-subtitle">
        Premium cake shop assistant for Sugar Bouquet India
      </p>
    </div>
  );
}
